import { render, staticRenderFns } from "./GroupActions.vue?vue&type=template&id=620f6cb4&scoped=true"
import script from "./GroupActions.vue?vue&type=script&lang=js"
export * from "./GroupActions.vue?vue&type=script&lang=js"
import style0 from "./GroupActions.vue?vue&type=style&index=0&id=620f6cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f6cb4",
  null
  
)

export default component.exports